import { diagnosticExplanation } from "./p2pDiagnostics";

export default function DiagnosticText({ message }: { message: string }) {
  const explanation = diagnosticExplanation(message);
  return <div className="p2p-diagnostic-message"><p>{explanation}</p>{explanation !== message && <details><summary>Технические подробности</summary><pre>{message}</pre></details>}</div>;
}
